import { getAuth, sendPasswordResetEmail } from "firebase/auth"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import styled from "styled-components"
import FormInput from "../components/FormInput"

const ResetPassword = () => {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)

  const handleResetPass = async e => {
    e.preventDefault()
    try {
      setLoading(true)
      const auth = getAuth()
      await sendPasswordResetEmail(auth, email)
      setLoading(false)
      toast.success("Check Your Email")
    } catch (error) {
      setLoading(false)
      console.log(error)
      toast.error(error.message)
    }
  }
  return (
    <>
    <ToastContainer/>
      <PageWrapp>
        <FormContainer onSubmit={handleResetPass}>
          <h2>Reset Password</h2>
          <FormInput
            type="email"
            value={email}
            isReq={true}
            handleOnChange={e => setEmail(e.target.value)}
            label={"Email Address*"}
            placeholder={"Email Address"}
          />

          <div>
            <GradientBtn type="submit">
              {loading ? "Sending link.." : "Send Reset Link"}
            </GradientBtn>
          </div>
        </FormContainer>
      </PageWrapp>
    </>
  )
}

export default ResetPassword

const PageWrapp = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
`

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 25%;
  max-width: 25%;
  height: 80%;
  h2 {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    text-transform: uppercase;
  }
  @media (max-width: 768px) {
    width: 80%;
    max-width: 80%;
    height: 50%;
  }
`
const GradientBtn = styled.button`
  border: none;
  background: ${({ theme }) => theme.accent};
  border-radius: 6px;
  width: 100%;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  height: 2.5rem;
`

const BtnLink = styled(Link)`
  text-decoration: none;
  font-size: 1rem;
  font-weight: normal;
  cursor: pointer;
  color: ${({ theme }) => theme.text};
`
